import {
    DashboardAction,
    DashboardStats,
    FETCH_DASHBOARD_STATS_FAILURE,
    FETCH_DASHBOARD_STATS_REQUEST,
    FETCH_DASHBOARD_STATS_SUCCESS,
} from './actions';

interface DashboardState {
  stats: DashboardStats | null;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  stats: null,
  loading: false,
  error: null,
};

const dashboardReducer = (
  state = initialState,
  action: DashboardAction
): DashboardState => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case FETCH_DASHBOARD_STATS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
